if (!customElements.get('advanced-product-upsell')) {
  class AdvancedProductUpsell extends HTMLElement {
    constructor () {
      super();
      this.observer = new MutationObserver(this.observerCallback.bind(this));
      this.observerConfig = { subtree: true, childList: true };
      this.blockID = this.dataset.blockId;
      this.title = this.dataset.title;
      this.root = this.closest('.advanced-product-upsell-container__wrapper');
      this.titleElement = null;
      if (this.root) {
        this.titleElement = this.closest('.advanced-product-upsell-container').querySelector('.advanced-product-upsell-container__title > span');
      }
      const blockSettingsData = this.querySelector(`*[data-params]`)?.textContent;
      try {
        if (blockSettingsData) {
          this.blockSettings = JSON.parse(blockSettingsData);
        }
      } catch (e) {
        console.error(e.message);
        this.blockSettings = {};
      }
    }

    getContainer () {
      return this.querySelector('[data-app-container]');
    }

    changeTagAndPreserveEvents (element, newTagName) {
      const newElement = document.createElement(newTagName);
      for (const attr of element.attributes) {
        newElement.setAttribute(attr.name, attr.value);
      }

      while (element.firstChild) {
        newElement.appendChild(element.firstChild);
      }

      const clone = element.cloneNode();
      clone.replaceWith(newElement);

      element.parentNode.replaceChild(newElement, element);

      return newElement;
    }

    createSlider () {
      const container = this.getContainer();
      const slides = container.querySelectorAll('.sg-pro-access-product');

      const root = document.createElement('div');
      root.setAttribute('id', 'custom-slider');
      root.setAttribute('slides-per-view', '1');
      root.setAttribute('space-between', '10');
      root.setAttribute('loop', 'true');
      root.setAttribute('centeredSlides', 'true');
      root.setAttribute('pagination-el', `#${this.blockID}-pagination`);
      root.setAttribute('navigation-next-el', `#${this.blockID}-button-next`);
      root.setAttribute('navigation-prev-el', `#${this.blockID}-button-prev`);
      root.setAttribute('pagination-type', 'bullets');
      root.setAttribute('pagination-clickable', 'true');
      root.setAttribute('speed', this.blockSettings?.slider_speed > 0 ? this.blockSettings?.slider_speed * 100 : 0);
      if (this.blockSettings?.slider_autoplay) {
        root.setAttribute('autoplay', 'true');
        const delay = this.blockSettings?.slider_delay > 0 ? this.blockSettings?.slider_delay * 100 : 0;
        root.setAttribute('autoplay-delay', delay);
        root.setAttribute('autoplay-disable-on-interaction', 'false');
        root.setAttribute('autoplay-pause-on-mouse-enter', 'true');
      }
      slides.forEach((item) => {
        const cloned = item.cloneNode(true);
        root.appendChild(cloned);
      });

      if (slides.length) {
        container.appendChild(root);
        slides.forEach((item) => item.remove());
      }
      return container.querySelector('#custom-slider');

    }

    atcClickHandle (e) {
      const root = e.target.closest('#sg_product_right_block');
      if (root) {
        const variantSelector = root.querySelector('[name="spice_select_variant_id"]');
        const quantitySelector = root.querySelector('[name="sg-pro-access-qty"]');
        if (variantSelector) {
          const variantID = variantSelector.value;
          const quantity = quantitySelector.value ? quantitySelector.value : 1;
          if (variantID) {
            const formData = {
              items: [
                {
                  id: variantID,
                  quantity: quantity,
                }],
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            }).then(response => {
              return response.json();
            }).catch((error) => {
              console.error('Error:', error);
            });
          }
        }
      }
    }

    prepared () {
      let slider = this.createSlider();
      if (slider) {
        slider.querySelectorAll('.sg-pro-access-product').forEach((item) => {
          const inputQuantity = item.querySelector('[name="sg-pro-access-qty"]');
          const wrapperDiv = document.createElement('div');
          const ATCButton = document.createElement('button');
          const title = item.querySelector('.sg-pro-access-product-title');
          if (title) {
            title.classList.add('large-up-hide');
            title.classList.add('upsell-product-title');
            title.classList.add('h5');
            const mainTitle = document.createElement('h5');
            mainTitle.classList.add('medium-hide');
            mainTitle.classList.add('small-hide');
            mainTitle.classList.add('upsell-product-title');
            mainTitle.innerHTML = title.innerHTML;
            item.prepend(mainTitle);
          }
          ATCButton.innerHTML = 'Add';
          ATCButton.setAttribute('data-atc', '');
          ATCButton.classList.add('advanced-button')
          if (inputQuantity) {
            wrapperDiv.appendChild(inputQuantity);
          }
          wrapperDiv.appendChild(ATCButton);
          wrapperDiv.classList.add('controls-wrapper');
          const parentContainer = item.querySelector('#sg_product_right_block');
          parentContainer.appendChild(wrapperDiv);
          const currentSlide = this.changeTagAndPreserveEvents(item, 'swiper-slide');
          const ATC = currentSlide.querySelector('[data-atc]');
          if (ATC) {
            ATC.addEventListener('click', this.atcClickHandle.bind(this));
          }
        });
        slider = this.changeTagAndPreserveEvents(slider, 'swiper-container');
        slider.style.setProperty('opacity', '1', 'important');
        const container = this.getContainer();
        const root = container.closest(`#block-${this.blockID}`);
        if (root) {
          root.style.display = 'block';
        } else {
          console.error('root not found');
        }
      }
    }

    observerCallback (mutations) {
      mutations.forEach((mutation) => {
        const container = this.getContainer();
        if (mutation.type === 'childList') {
          if (mutation.target.id === container.id) {
            const product = Array.from(mutation.addedNodes).
              find((item) => {return item.classList.contains('sg-pro-access-product');});
            if (product) {
              this.observer.disconnect();
              this.prepared();
            }
          }
        }
      });
    }

    disconnectedCallback () {
      const container = this.getContainer();
      if (container) {
        this.observer.disconnect();
        this.container.querySelectorAll('[data-atc]').forEach((item) => {
          item.removeEventListener('click', this.atcClickHandle.bind(this));
        });
      }
    }

    replaceBlobVariables (template, replacementValue) {
      return template.replace(/\[.*?\]/g, replacementValue);
    }

    hasBlobVariables (template) {
      return /\[(.*?)\]/.test(template);
    }

    preparedTitle (smartCart, totalPrice) {
      const util = window.Rebuy.util;
      const total = totalPrice;
      let freeGiftLimit = null;
      let title = null;
      const tiers = smartCart?.progressBar?.tiers ?? [];
      if (total!==null) {
        for (let tier of tiers) {
          if (tier?.type === 'product') {
            freeGiftLimit = tier?.minimum ? util.amountToCents(tier.minimum * 100) : null;
            break;
          }
        }
      }
      if (freeGiftLimit !== null) {
        let rest = freeGiftLimit - total;
        if (rest > 0) {
          rest = util.formatMoney(rest);
          title = this.replaceBlobVariables(this.title, rest);
          this.titleElement.innerHTML = title;
        } else {
          this.titleElement.innerHTML = '';
        }
      }
    }

    setTitle () {
      if (!this.titleElement) {
        return;
      }

      if (this.hasBlobVariables(this.title)) {
        document.addEventListener('rebuy:smartcart.ready', (event) => {
          const smartCart = event?.detail?.smartcart ?? null;
          if (smartCart && window?.Rebuy) {
            const rebuyCart = Rebuy.Cart;
            rebuyCart?.watchCart((event) => {
              this.preparedTitle(smartCart, event.total_price);
            });
            this.preparedTitle(smartCart, smartCart.cart.total_price);
          }
        });
      } else {
        this.titleElement.innerHTML = this.title;
      }
    }

    connectedCallback () {
      requestAnimationFrame(() => {
        this.setTitle();
        const container = this.getContainer();
        this.blockID = this.dataset.blockId;
        if (container) {
          const product = container.querySelector('.sg-pro-access-product');
          if (product) {
            this.prepared();
          } else {
            this.observer.observe(container, this.observerConfig);
          }
        }
      });
    }
  }

  customElements.define('advanced-product-upsell', AdvancedProductUpsell);
}